export default __webpack_public_path__ + "static/media/ch-gr.2ccc0361.svg";